import ApiService from '../common/api.service';

import {
  FETCH_PORTICOS,
} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
};

const getters = {
};

const actions = {
  [FETCH_PORTICOS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('accesos/obtener_porticos', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
